/**
 * OpenList 文件浏览器头部组件
 */

"use client"

import { Button } from "@/components/ui/button"
import { CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Folder, Loader2, Search } from "lucide-react"

interface OpenListHeaderProps {
  subjectName: string
  searchTerm: string
  isSearching: boolean
  onSearchTermChange: (term: string) => void
  onSearch: () => void
}

export function OpenListHeader({
  subjectName,
  searchTerm,
  isSearching,
  onSearchTermChange,
  onSearch,
}: OpenListHeaderProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch()
    }
  }

  return (
    <CardHeader>
      <CardTitle className="flex items-center justify-between">
        <div className="flex items-center">
          <Folder className="h-5 w-5 mr-2 text-yellow-500" />
          {subjectName} - 学习资料
        </div>
      </CardTitle>

      {/* 搜索框 */}
      <div className="flex space-x-2">
        <div className="relative flex-1">
          <Search className="h-4 w-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <Input
            placeholder="搜索资料..."
            value={searchTerm}
            onChange={e => {
              onSearchTermChange(e.target.value)
            }}
            onKeyDown={handleKeyDown}
            className="pl-9"
          />
        </div>
        <Button onClick={onSearch} disabled={isSearching}>
          {isSearching ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Search className="h-4 w-4" />
          )}
        </Button>
      </div>
    </CardHeader>
  )
}
